var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16793 0.677368C3.16793 0.298421 3.34995 0.0947366 3.6533 0.0899998C3.79632 0.085263 3.948 0.161052 4.07801 0.293684L7.73131 3.91737C7.88299 4.07368 8 4.26789 8 4.49526C8 4.73211 7.89166 4.91684 7.73131 5.07789L4.07801 8.69684C3.948 8.82947 3.79632 8.90053 3.6533 8.90053C3.34995 8.90053 3.16793 8.69211 3.16793 8.31316L3.16793 0.677368ZM4.43087e-07 0.772105C4.64207e-07 0.288947 0.273023 -3.37757e-07 0.71506 -3.18435e-07L1.49946 -2.84148e-07C1.9415 -2.64826e-07 2.21452 0.288947 2.21452 0.772105L2.21452 8.22789C2.21452 8.71105 1.9415 9 1.49946 9L0.715059 9C0.273023 9 9.60649e-08 8.71105 1.17184e-07 8.22789L4.43087e-07 0.772105Z",
    fill: "#46C367"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartIcon);
export default __webpack_public_path__ + "static/media/start-icon.ab1e99305cbdc5066cc4d84926a36fd1.svg";
export { ForwardRef as ReactComponent };